import ApiService from "@/services/api.service"

/// *** Superadmin Service *** ///

export const SuperadminService = {
  loadRights(clinic_id) {
    return ApiService.get(`superadmin/clinic/${clinic_id}/rights`)
  },
  toggleRight(clinic_id, params) {
    return ApiService.post(`superadmin/clinic/${clinic_id}/rights`, params)
  },
  tariffFunctionality(tariff_id) {
    return ApiService.get(`superadmin/tariff/${tariff_id}/functionality`)
  },
  updateTariffFunctionality(tariff_id, params) {
    return ApiService.post(`superadmin/tariff/${tariff_id}/functionality`, params)
  },
  tariffsForClinic(clinic_id) {
    return ApiService.get(`superadmin/clinic/${clinic_id}/tariffs`)
  },
  allTariffs() {
    return ApiService.get(`superadmin/clinic/tariffs/all`)
  },
  saveTariffsForClinic(clinic_id, params) {
    return ApiService.post(`superadmin/clinic/${clinic_id}/tariffs`, params)
  },
  nullifyPayment(clinic_id) {
    return ApiService.delete(`superadmin/clinic/${clinic_id}/tariffs/nullify`)
  },
  analyzeImportFile(clinic_id, params) {
    return ApiService.post(`superadmin/import/patients/${clinic_id}/action/analyze`, params)
  },
  analyzeServicesImportFile(clinic_id, params) {
    return ApiService.post(`superadmin/import/services/${clinic_id}/action/analyze`, params)
  },
  importPatientsFile(clinic_id, params) {
    return ApiService.post(`superadmin/import/patients/${clinic_id}/action/import`, params)
  },
  importServicesFile(clinic_id, params) {
    return ApiService.post(`superadmin/import/services/${clinic_id}/action/import`, params)
  },
  getPatientImports(clinic_id) {
    return ApiService.get(`superadmin/import/patients/${clinic_id}/imports`)
  },
  getServicesImports(clinic_id) {
    return ApiService.get(`superadmin/import/services/${clinic_id}/imports`)
  },
  cancelImport(clinic_id, import_id) {
    return ApiService.post(`superadmin/import/patients/${clinic_id}/import/${import_id}/cancel`)
  },
  importServices(clinic_id) {
    return ApiService.post(`superadmin/import/services/${clinic_id}/standard`)
  },
  toggleBlockedClinic(clinic_id, status) {
    return ApiService.post(`superadmin/clinic/${clinic_id}/block`, { blocked: status })
  },
  sendPush(params, message) {
    return ApiService.post(`superadmin/push/send`, { params: params, message: message })
  },
  restoreUser(userId) {
    return ApiService.post(`superadmin/user/${userId}/restore`)
  },
  legalAgreementStatus(userId) {
    return ApiService.get(`superadmin/user/${userId}/legal-agreement-status`)
  },
  resetUserPassword(clinicId, userId) {
    return ApiService.post(`superadmin/clinic/${clinicId}/user/${userId}/password/reset`)
  },
  generateAPIAccess(params) {
    return ApiService.post(`superadmin/api/access`, params)
  },
  resetAPIAccessPassword(id, params = {}) {
    return ApiService.post(`superadmin/api/access/${id}/reset`, params)
  },
  resetAPIAccessIP(id) {
    return ApiService.post(`superadmin/api/access/${id}/ip/reset`)
  },
  cleanClinicData(clinic_id) {
    return ApiService.delete(`superadmin/clinic/${clinic_id}/clean`)
  },
  populateDemoData(clinic_id) {
    return ApiService.post(`superadmin/clinic/${clinic_id}/demo/populate`)
  },
  getDeveloperMonitoring(date) {
    return ApiService.get(`superadmin/developer/monitoring?date=${date}`)
  },
  getDeveloperQueueStat(date) {
    return ApiService.get(`superadmin/developer/queue_stat?date=${date}`)
  },
  getDeveloperGraphs(from, to) {
    return ApiService.get(`superadmin/developer/graphs?from=${from}&to=${to}`)
  },
  loadFile(fileName) {
    return ApiService.post(`superadmin/developer/file/load`, { fileName })
  },
  loadBonuses(params) {
    return ApiService.get(`superadmin/bonuses`, params)
  },
  requestClinicAuthAccess(params) {
    return ApiService.post(`superadmin/access/request`, params)
  },
  hideAccessRequests(params) {
    return ApiService.post(`superadmin/access/request/close`, params)
  },
  refreshOnlineContractPayment(id) {
    return ApiService.post(`superadmin/onlinecontract/payment/${id}/refresh`)
  },
  getOnlineContractOrderLink(id) {
    return ApiService.post(`superadmin/onlinecontract/payment/${id}/pdf`)
  },
  getSuperadmins() {
    return ApiService.get(`superadmin/superadmins`)
  },
  toggleDeletionQueue(clinic_id, action, params = {}) {
    return ApiService.post(`superadmin/clinic/${clinic_id}/delete/queue/${action}`, params)
  },
  translate(params = {}) {
    return ApiService.post(`superadmin/developer/translate`, params)
  }
}
